'use strict';

//Mobile apps service used to communicate Mobile apps REST endpoints
angular.module('mobile-apps').factory('TagCategories', ['$resource',
    function($resource) {

        return $resource('/v1/projects/:mobileAppId/tagCategories/:tagCategoryId',
            {
                tagCategoryId    : '@_id',
                mobileAppId : '@mobileAppId',
                tagCategories: '@tagCategories'
            },
            {
                get:
                {
                    method:'GET',
                    cache: false
                },
                list:
                {
                    method:'GET',
                    cache: false,
                    isArray: true
                },
                create:
				{
					method: 'POST',
                    cache: false,
                    isArray: true
				},
				update:
				{
					method: 'PUT',
					cache: false,
				},
				remove:
				{
					method: 'DELETE',
                    cache: false,
                    isArray: true
				}
            }
        );
    }
]);
